
import "./Partner.scss";
import PartnerComponent from "./components/Partner";

const PartnerPage = () => {
  return (
    <PartnerComponent guid={localStorage.getItem("partner_guid")} name={localStorage.getItem("companyName")} titleCompany="Your" />
  )
}


export default PartnerPage;
